<template>
  <el-dialog
    :title="$t('menu.errCode')"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('menu.errCode')">
          <el-input v-model="ruleForm.errorCode" style="width:500px;" v-if="this.codeInfo.errorCode==null"/>
          <el-input v-model="ruleForm.errorCode" style="width:500px;" readonly v-else/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text355')">
          <el-input v-model="ruleForm.errorName" style="width:500px;"/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text339')">
          <el-select
            v-model="ruleForm.hwType"
            style="width:500px;"
            clearable
            :placeholder="$t('public.text5')"
          >
            <el-option :label="$t('pages.equipment.text178')" :value="10"/>
            <el-option :label="$t('pages.equipment.text202')" :value="15"/>
            <el-option :label="$t('pages.equipment.text203')" :value="20"/>
            <el-option :label="$t('pages.equipment.text204')" :value="25"/>
            <el-option :label="$t('pages.equipment.text205')" :value="30"/>
            <el-option :label="$t('pages.equipment.text206')" :value="35"/>
            <el-option :label="$t('pages.equipment.text207')" :value="40"/>
            <el-option :label="$t('pages.equipment.text208')" :value="45"/>
            <el-option :label="$t('pages.equipment.text347')" :value="50"/>
            <el-option :label="$t('pages.equipment.text348')" :value="55"/>
            <el-option :label="$t('pages.equipment.text349')" :value="60"/>
            <el-option :label="$t('pages.equipment.text350')" :value="65"/>
            <el-option :label="$t('pages.equipment.text362')" :value="70"/>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submit">{{$t("button.determine")}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        protocolId: null,
        errorCode: null,
        errorName: null,
        hwType: null,
      },
      rules: {
        errorCode: {
          required: true,
          message: this.$t("pages.equipment.text351"),
          trigger: "change",
        },
        hwType: {
          required: true,
          message: this.$t("pages.equipment.text352"),
          trigger: "change",
        },
        errorName: {
          required: true,
          message: this.$t("pages.equipment.text361"),
          trigger: "change",
        },
      },
    };
  },
  // 监听弹窗类型
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.codeInfo!=null||this.codeInfo.protocolId!=null) {
          this.ruleForm.protocolId = this.codeInfo.protocolId;
          this.ruleForm.errorCode = this.codeInfo.errorCode;
          this.ruleForm.errorName = this.codeInfo.errorName;
          this.ruleForm.hwType = this.codeInfo.hwType;
        }
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  mounted() {},
  props: ["dialogVisible","codeInfo"],
  methods: {
    //关闭弹窗
    handleClose() {
      this.ruleForm = {
        protocolId: null,
        errorCode: null,
        errorName: null,
        hwType: null,
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //提交
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request.errCodeEdit(this.ruleForm)
            .then(() => {
              this.$message.success(this.$t("public.text9"));
              this.$emit("codeList");
              this.handleClose();
            })
            .catch(() => {});
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>